// Sets the target Turbo Frame's src directly from a form's fields — avoids the
// Turbo Drive gate which blocks requestSubmit() when session.drive = false.
export function navigateFrame(form, { restoreFocus = false } = {}) {
  const frameId = form?.dataset.turboFrame
  const frame = frameId && document.getElementById(frameId)
  if (!frame) return

  const params = new URLSearchParams(
    [...new FormData(form)].filter(([, v]) => v)
  )

  if (restoreFocus) {
    const active = document.activeElement
    const focusedName = active?.name
    const selStart = active?.selectionStart
    const selEnd = active?.selectionEnd
    if (focusedName) {
      frame.addEventListener(
        'turbo:frame-load',
        () => {
          const el = frame.querySelector(`[name="${CSS.escape(focusedName)}"]`)
          if (!el) return
          el.focus()
          if (selStart != null) el.setSelectionRange(selStart, selEnd)
        },
        { once: true }
      )
    }
  }

  frame.src = `${form.action}?${params}`
}

export function debounce(fn, delay = 400) {
  let timer
  return () => {
    clearTimeout(timer)
    timer = setTimeout(fn, delay)
  }
}
